import { render, staticRenderFns } from "./InstructionsModal.vue?vue&type=template&id=ba317972&scoped=true&"
import script from "./InstructionsModal.vue?vue&type=script&lang=js&"
export * from "./InstructionsModal.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsModal.vue?vue&type=style&index=0&id=ba317972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba317972",
  null
  
)

export default component.exports